export default "__VITE_ASSET__4$13VsUb__"